var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoJustwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.516,
    height: 25.937,
    viewBox: "0 0 111.516 25.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(47.924 6.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M549.794,277.9,546.7,267.431h-1.368v-2.8h6.545v2.8h-1.666l3.065,10.473Zm5.8-7.141-1.7,6.248-1.369-4.641,1.577-5.921Zm1.993-6.129,4.552,13.269h-3.273l-4.552-13.269Zm3.243,6.962,1.13-4.165h-1.636v-2.8h6.4v2.8h-1.369l-2.737,9.342Z",
    transform: "translate(-545.332 -264.634)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(0 0.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M127.254,231.02v3.132a6.7,6.7,0,0,1-2.954-.567v-3.013a5.123,5.123,0,0,0,2.208.537A2.837,2.837,0,0,0,127.254,231.02Zm-.6-13.036v-2.8h5.071v14.558a3.947,3.947,0,0,1-3.49,4.3V217.984Zm1.074-7.07a2.118,2.118,0,0,1,4.236,0,2.118,2.118,0,0,1-4.236,0Z",
    transform: "translate(-124.3 -208.825)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    transform: "translate(9.205 6.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M213.935,275.36v2.864a5.942,5.942,0,0,1-.716.03c-4.087,0-6.474-1.1-6.474-5.012v-5.787h-1.581v-2.8h5.071v8.293c0,1.76.806,2.416,2.864,2.416Zm6.056,2.178c-1.79.328-3.669.537-5.072.656V267.455h-1.611v-2.8h5.1v10.441l1.581-.3Z",
    transform: "translate(-205.165 -264.651)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(25.7 6.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M353.964,275.869v-2.655a4.327,4.327,0,0,0,.9.089c1.074,0,2.058-.388,2.058-1.372,0-.925-.776-1.223-2.357-1.551-3.132-.567-4.475-1.85-4.475-4.117,0-2.8,2.3-4.236,5.31-4.236a3.5,3.5,0,0,1,.477.03v2.625a3.746,3.746,0,0,0-.477-.03c-1.163,0-1.82.537-1.82,1.313,0,.746.477,1.134,2.029,1.462,3.55.686,4.8,1.939,4.8,4.326,0,2.834-2.3,4.176-5.549,4.176C354.561,275.929,354.263,275.9,353.964,275.869Zm-3.788-4.415h2.894v4.3a8.693,8.693,0,0,1-2.894-.984Zm6.593-5.071v-4.236a8.831,8.831,0,0,1,2.923.895v3.341Z",
    transform: "translate(-350.086 -262.027)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(37.036 3.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M449.672,239.334h2v-3.252h3.46v11.635c0,1.551.716,2.028,1.79,2.028a4.453,4.453,0,0,0,2.446-.746v3.192a6.948,6.948,0,0,1-3.371.746c-2.3,0-4.326-1.1-4.326-4.3v-6.5h-2Zm6.444,2.8v-2.8h3.132v2.8Z",
    transform: "translate(-449.672 -236.082)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(86.287 6.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M882.36,264.344a21.357,21.357,0,0,1,5.087-1.161v10.532h2.291v2.8H882.36v-2.8h1.606v-6.873l-1.606.387Zm6.069,1.874v-3.124c.327-.03.8-.03.893-.03a10.1,10.1,0,0,1,2.5.327v3.154a6.885,6.885,0,0,0-2.5-.387A4.969,4.969,0,0,0,888.429,266.218Z",
    transform: "translate(-882.36 -263.064)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    transform: "translate(96.759 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M974.362,203.467h5.088V220.9h1.458v2.8h-6.545v-2.8h1.577V206.264h-1.577ZM987.215,220.9h1.9v2.8h-3.868l-5.147-6.278,2.35-2.38Zm-4.165-6.457,1.25-1.279h-1.9v-2.737h6.635v2.8H987.9l-3.243,3.124Z",
    transform: "translate(-974.362 -203.467)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(69.737 6.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(0.276 0.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M742.589,265.832l1.034,1.788a5.2,5.2,0,0,0,2.5,9.37v2.075a7,7,0,0,1-2.937-.859,7.1,7.1,0,0,1-3.3-3.762A7.227,7.227,0,0,1,742.589,265.832Z",
    transform: "translate(-739.391 -265.832)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M744.259,276.229l-.3-.021a7.314,7.314,0,0,1-3.055-.894,7.4,7.4,0,0,1-3.433-3.909,7.531,7.531,0,0,1,2.816-8.952l.252-.166,1.306,2.259-.188.153a4.915,4.915,0,0,0,2.369,8.869l.237.04ZM740.348,263.1A6.967,6.967,0,0,0,738,271.2a6.843,6.843,0,0,0,3.176,3.614,6.722,6.722,0,0,0,2.515.8v-1.526a5.464,5.464,0,0,1-2.583-9.672Z",
    transform: "translate(-736.966 -262.287)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(76.213 4.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M793.86,251.971v-6.208h2.612v6.208Z",
    transform: "translate(-793.86 -245.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(78.01 6.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(0.284 0.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M815.683,265.832l-1.033,1.788a5.2,5.2,0,0,1-2.5,9.37v2.075a7,7,0,0,0,2.938-.859,7.1,7.1,0,0,0,3.3-3.762A7.227,7.227,0,0,0,815.683,265.832Z",
    transform: "translate(-812.148 -265.832)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M809.649,276.229v-2.62l.237-.04a4.915,4.915,0,0,0,2.369-8.869l-.188-.153,1.306-2.259.252.166a7.531,7.531,0,0,1,2.816,8.952,7.4,7.4,0,0,1-3.433,3.909,7.315,7.315,0,0,1-3.055.894Zm.569-2.143v1.526a6.721,6.721,0,0,0,2.515-.8,6.843,6.843,0,0,0,3.176-3.614,6.967,6.967,0,0,0-2.349-8.1l-.759,1.314a5.464,5.464,0,0,1-2.583,9.672Z",
    transform: "translate(-809.649 -262.287)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJustwork);
export default __webpack_public_path__ + "static/media/logo-justwork.9d06358624eec6f11ab8b1b48baedf9d.svg";
export { ForwardRef as ReactComponent };